module.exports = __webpack_public_path__ + "img/hr-tree-04-a-trunk.b59f3260.png";